// extracted by mini-css-extract-plugin
export default {"importContainer":"adminElement_importContainer__2njm9"};